module.exports = __webpack_public_path__ + "static/media/heroimage_igib-013.9958b997.jpg";